'use client';

import { useEffect, useState } from 'react';

import { FloatingParticles } from './indicator-components/floating-particles';
import { ProgressRing } from './indicator-components/progress-ring';
import { STEP_PROGRESS, useAIPlannerStore } from '@/store/ai-planner';

export function StepIndicator() {
  const currentStep = useAIPlannerStore.use.currentStep();
  const [displayProgress, setDisplayProgress] = useState(0);
  const [isGenerating, setIsGenerating] = useState(false);

  const targetProgress = STEP_PROGRESS[currentStep] || 0;

  useEffect(() => {
    if (targetProgress === displayProgress) return;

    setIsGenerating(true);
    const duration = 1500;
    const steps = 60;
    const increment = (targetProgress - displayProgress) / steps;
    const stepDuration = duration / steps;

    let currentValue = displayProgress;
    const interval = setInterval(() => {
      currentValue += increment;
      if (
        (increment > 0 && currentValue >= targetProgress) ||
        (increment < 0 && currentValue <= targetProgress)
      ) {
        setDisplayProgress(targetProgress);
        setIsGenerating(false);
        clearInterval(interval);
      } else {
        setDisplayProgress(Math.round(currentValue));
      }
    }, stepDuration);

    return () => clearInterval(interval);
  }, [targetProgress, displayProgress]);

  return (
    <div className="flex items-center justify-center gap-8">
      <div className="relative">
        <div className="glow-effect" />
        <ProgressRing progress={displayProgress} isGenerating={isGenerating} />
        <FloatingParticles />
      </div>
    </div>
  );
}
// Compact version for inline use
export function StepIndicatorCompact() {
  const currentStep = useAIPlannerStore.use.currentStep();
  const progress = STEP_PROGRESS[currentStep] || 0;

  return (
    <div className="flex items-center gap-2">
      <div className="relative size-10">
        <svg className="size-full -rotate-90" viewBox="0 0 40 40">
          <circle
            cx="20"
            cy="20"
            r="16"
            fill="none"
            stroke="rgba(255, 255, 255, 0.1)"
            strokeWidth="3"
          />
          <circle
            cx="20"
            cy="20"
            r="16"
            fill="none"
            stroke="#ff8200"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray={2 * Math.PI * 16}
            strokeDashoffset={2 * Math.PI * 16 * (1 - progress / 100)}
            className="transition-all duration-500 ease-out"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-[#ff8200] text-xs font-bold">{progress}%</span>
        </div>
      </div>
    </div>
  );
}
